class CalendlyInit {
  constructor() {
    this.loadCalendlyScript()
  }

  // Load Calendly
  loadCalendlyScript = (callback) => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.onload = callback;
    document.body.appendChild(script);
  }

  // Open Calendly with dynamic ID
  openCalendly = (elementId, url) => {
    window.addEventListener('load', () => {
      const parentElement = document.getElementById(elementId);
      if (!parentElement) {
        console.error(`Element with ID "${elementId}" not found.`);
        return;
      }

      if (!url) {
        console.error(`Calendly URL not defined.`);
        return;
      }

      if (window.Calendly) {
        window.Calendly.initInlineWidget({
          url: url,
          parentElement: parentElement,
          resize: true,
        });
      } else {
        console.error('Calendly script is not loaded yet.');
      }
    })
  }
}

export default new CalendlyInit();